/**
 * Scripture blockquote — renders the "It is written..." passage
 * with a styled left-border accent.
 */

interface ScriptureBlockProps {
  text: string;
  reference: string;
}

export function ScriptureBlock({ text, reference }: ScriptureBlockProps) {
  return (
    <blockquote className="scripture-block">
      <p className="scripture-block-label">It is written...</p>
      <p className="scripture-block-text">&ldquo;{text}&rdquo;</p>
      <cite className="scripture-block-ref">&mdash; {reference}</cite>
    </blockquote>
  );
}
